const baseURL = process.env.NEXT_PUBLIC_BASE_URL_PROFILE;

export const AUTH_ENDPOINTS = {
  CONVERT: `${baseURL}/auth/jek`,
  REFRESH: `${baseURL}/auth/refresh-token`,
  ME: `${baseURL}/user/me`,
  B2B_PROFILE: `${baseURL}/b2b/profile`,
  UPDATE_ME: `${baseURL}/user/me`,
  LOGIN: `${baseURL}/auth/password`
};

export const REFRESH_BUFFER_MS = 10 * 60 * 1000;

export const TOKEN_STORAGE_KEY = "st_token";
export const REFRESH_TOKEN_STORAGE_KEY = "st_refresh_token";

export const LEGACY_ACCESS_TOKEN_KEY = "access-token";
export const LEGACY_REFRESH_TOKEN_KEY = "refresh-token";
